import { connect } from 'react-redux';

import FilterByValueConfirmDialog from './FilterByValueConfirmDialog';

import { toggleFilterUserInput, updateFilterUserInputValue } from '../BarChartFilterActions';

import { filtersItems } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';

function mapStateToProps (state, ownProps) {
  const { filterId } = ownProps;

  return {
    filter: filtersItems(state).get(filterId),
  };
}

const mapActionsToProps = {
  toggleFilterUserInput,
  updateFilterUserInputValue,
};

export default connect(mapStateToProps, mapActionsToProps)
  (FilterByValueConfirmDialog);
